import { render, staticRenderFns } from "./GaViaJsTest.vue?vue&type=template&id=50f4ae3a&scoped=true&"
import script from "./GaViaJsTest.vue?vue&type=script&lang=js&"
export * from "./GaViaJsTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f4ae3a",
  null
  
)

export default component.exports